/* eslint-disable no-console */

import type { ApiErrorResponse } from '@rover/types/src/ApiErrorResponse';
import type { ApiErrorMessage } from '@rover/utilities/APIError';
import APIError, { apiErrorMessageFallback } from '@rover/utilities/APIError';
import parseApiErrors, { DEFAULT_ERROR_MESSAGE } from '@rover/utilities/parseApiErrors';

type ParsedErrors = ApiErrorMessage[];

const DefaultAPIErrorHandler = (
  error: ApiErrorResponse | Error, // If the error happens during the API call, we'll get an ApiErrorResponse, if it happens in code, we'll get a generic Error
  defaultErrorMessage: ApiErrorMessage = DEFAULT_ERROR_MESSAGE
): never => {
  if (!('response' in error)) throw error; // Generic Error, so no processing is necessary
  if (!error.response) throw error;

  const { response } = error;
  const errors: ParsedErrors = parseApiErrors(response);
  const message = errors.length ? (errors.pop() as ApiErrorMessage) : defaultErrorMessage;
  const errorType = response.data?.error_type;

  // FE-3685 Don't console.error during jest tests, it is noisy.
  if (!process.env.JEST_WORKER_ID) {
    console.error(
      `Error in DefaultAPIErrorHandler: STATUS: ${
        response.status
      }, MESSAGE: ${apiErrorMessageFallback(message)}`
    );
  }

  // @ts-expect-error
  throw new APIError(message, response.status, errorType); // we throw the Error so that a duck can catch it and handle it
};

export default DefaultAPIErrorHandler;
